export const DEFAULT_VALUE = {
  BUTTON_ACTION: 'CONTINUE',
  COLLECT_BILLING_ADDRESS: 'FULL',
  COLLECT_SHIPPING: true,
  PAYLOAD_TYPE_INDICATOR: 'SUMMARY',
  THREE_DS_ACTIVE: false,
  TRANSACTION_TYPE: 'PURCHASE'
};

export const billingPreferenceMap = {
  ALL: 'FULL',
  NONE: 'CNTRY',
  POSTAL_COUNTRY: 'POSTALCNTRY'
};

export const shippingPreferencesMap = {
  ALL: true,
  NONE: false,
  POSTAL_COUNTRY: true
};

export const threeDsPreferenceMap = {
  ONBEHALF: true
};

export const BUTTON_ACTION = {
  CONTINUE: 'CONTINUE',
  PAY: 'PAY'
};

export const CONSUMER_IDENTITY_ENUMS = ['EMAIL', 'MOBILE_NUMBER', 'CUSTOM_IDENTIFIER'];

export const PAYLOAD_TYPE_INDICATOR_ENUM = ['FULL', 'SUMMARY', 'PAYMENT', 'NON_PAYMENT', 'NONE'];

export const TRANSACTION_TYPE_ENUM = ['PURCHASE', 'BILL_PAYMENT', 'MONEY_TRANSFER'];
